<template>
  <el-dialog
    title="物流轨迹"
    :visible.sync="visible"
    :before-close="handleClose"
  >
    <el-alert :title="title" :closable="false"></el-alert>
    <el-table :data="steps">
      <el-table-column
        property="time"
        label="时间"
        width="180"
      ></el-table-column>
      <el-table-column property="action" label="状态" width="100">
        <template slot-scope="scope">
          {{ actionName(scope.row.action) }}
        </template>
      </el-table-column>
      <el-table-column property="station_name" label="地址"></el-table-column>
      <el-table-column
        property="description"
        label="描述"
        width="200"
      ></el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  props: ["visible", "steps", "status", "mailNo"],
  data() {
    return {
      actionMap: {
        ACCEPT: "收件扫描",
        GOT: "揽件扫描",
        ARRIVAL: "入中转",
        DEPARTURE: "出中转",
        SENT: "派件中",
        INBOUND: "第三方代收入库",
        SIGNED: "已签收",
        OUTBOUND: "第三方代收快递员取出",
        SIGNFAIL: "签收失败",
        RETURN: "退回件",
        ISSUE: "问题件",
        REJECTION: "拒收",
        OTHER: "其他",
        OVERSEA_IN: "入库扫描",
        OVERSEA_OUT: "出库扫描",
        CLEARANCE_START: "清关开始",
        CLEARANCE_FINISH: "清关结束",
        CLEARANCE_FAIL: "清关失败",
        OVERSEA_ARRIVAL: "干线到达",
        OVERSEA_DEPARTURE: "干线离开",
        TRANSFER: "转单",
      },
      statusMap: {
        GOT: "已揽件",
        TRANSIT: "运输中",
        SIGNED: "已签收",
        RETURN: "退回件",
        SIGNFAIL: "异常签收",
      },
    };
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
  computed: {
    actionName() {
      return (action) => {
        return this.actionMap[action];
      };
    },
    title() {
      const statusStr = this.statusMap[this.status] || "暂无";
      return `快递单号:${this.mailNo},当前状态:${statusStr}`;
    },
  },
};
</script>
